const ACTIONS = {
    CREATE_REQUEST: "CREATE_PURCHASE_REQUEST",
    CREATE_SUCCESS: "CREATE_PURCHASE_SUCCESS",
    CREATE_FAIL: "CREATE_PURCHASE_FAIL",

    FETCH_REQUEST: "FETCH_PURCHASE_REQUEST",
    FETCH_SUCCESS: "FETCH_PURCHASE_SUCCESS",
    FETCH_FAIL: "FETCH_PURCHASE_FAIL",

    FETCH_ALL_REQUEST: "FETCH_ALL_PURCHASE_REQUEST",
    FETCH_ALL_SUCCESS: "FETCH_ALL_PURCHASE_SUCCESS",
    FETCH_ALL_FAIL: "FETCH_ALL_PURCHASE_FAIL",

    UPDATE_REQUEST: "UPDATE_PURCHASE_REQUEST",
    UPDATE_SUCCESS: "UPDATE_PURCHASE_SUCCESS",
    UPDATE_FAIL: "UPDATE_PURCHASE_FAIL",

    DELETE_REQUEST: "DELETE_PURCHASE_REQUEST",
    DELETE_SUCCESS: "DELETE_PURCHASE_SUCCESS",
    DELETE_FAIL: "DELETE_PURCHASE_FAIL",

};

export default ACTIONS;
